import { upperFirst } from "es-toolkit";

//#region ../base/upload/util.ts
/**
* Sanitize filename string
*/
function cleanFilename(name) {
	if (typeof name === "undefined") return void 0;
	const parts = name.split(".");
	if (parts.length >= 2) parts.pop();
	const filename = parts.join(".");
	return filename.replace(/(_|-{2,})/g, " ").replace(/\w\S*/g, (txt) => {
		return upperFirst(txt);
	});
}

//#endregion
export { cleanFilename };